import makeHttpRequest from '../helpers/ajax';
import wwwUrlEnv from '../helpers/www-url-env';

const setApiUrl = (streetAddressArray) => {
    let result = '';
    if (streetAddressArray != null && streetAddressArray.length > 0) {
        result = `${wwwUrlEnv.getWWWURL()}/wp-json/homeValue/v1/getHomeValue?street=${encodeURIComponent(streetAddressArray[0].trim())}&city=${encodeURIComponent(streetAddressArray[1].trim())}&state=${encodeURIComponent(streetAddressArray[2].trim())}&zip=${encodeURIComponent(streetAddressArray[3].trim())}`;
    }
    return result;
};

export default {
    getHomeValuationData: async (streetAddress) => {
        if (streetAddress === '') {
            // eslint-disable-next-line prefer-promise-reject-errors
            return Promise.reject({ isSuccess: false });
        }

        const streetAddressArray = streetAddress.split(',');
        const url = setApiUrl(streetAddressArray);

        try {
            const response = await makeHttpRequest({ url });
            const data = JSON.parse(response);
            return Promise.resolve(data);
        } catch (error) {
            return Promise.reject(error);
        }
    },
};
